import React from 'react';
import ContactImg from '../../assets/contact.svg';
import YoungPharm from '../../assets/young_pharm.svg'
import { FaTelegramPlane } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { BiSolidEnvelope } from "react-icons/bi";
import { FaLocationDot } from "react-icons/fa6";

const Contact = () => {
    return (
        <div className=' md:my-[5em] max-w-[85%] mx-auto '>
            <div className='flex justify-center my-6'>
                <img src={ContactImg} className=' w-[9em] md:w-[11em] ' alt='Illustration representing contact methods' />
            </div>
            <div className='grid md:grid-cols-2 gap-4 mb-6 '>
                <div className='hidden md:block'>
                    <img src={YoungPharm} className='' alt='Illustration of a young pharmacist holding medication'/>
                </div>

                <div className='border  shadow-blue-300 my-auto rounded-lg bg-gradient-to-l from-[#0A436C] to-[#308ED7] h-[36em]'>
                    <form className=' px-8 py-12   '>
                        <div className='grid md:grid-cols-2 gap-4'>
                            <input className=' p-2 rounded-md h-10 border-[1px] ' placeholder='Your name' />
                            <input className=' p-2 rounded-md h-10 border-[1px] ' placeholder='Your email' />
                        </div>
                        <textarea rows={1} className='w-full border-[1px] p-2 mt-3  rounded-lg' placeholder='message' />

                        <div className='flex justify-center mt-4'>
                            <button className='bg-[#00A9FF] px-4 py-2 text-white rounded-full flex items-center'><p className='text-xs font-medium'>Send</p><FaTelegramPlane size={24} color='white' /></button>
                        </div>
                        <div className='w-[70%] border-b border-gray-400 mt-5 mx-auto'>

                        </div>

                        <div className='grid grid-cols-1 md:grid-cols-2 mt-4 gap-y-4'>
                            <div className=' flex  items-center gap-2  text-white  '>
                                <BsFillTelephoneFill className="text-2xl md:text-3xl"/>
                                <address className='text-sm not-italic'>
                                    <p className='font-semibold'>Call Us</p>
                                    <a href="tel:+233303964289">+233 (0)30 396 4289</a>
                                </address>
                            </div>
                            <div className='flex  items-center gap-2  text-white '>
                                <FaLocationDot className="text-2xl md:text-3xl"/>
                                <address className='text-sm not-italic'>
                                    <p className='font-semibold'>Our Address</p>
                                    <a
                                        href="https://maps.google.com/?q=Basket Junction, Spintex Road, Accra, Ghana"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Basket Junction, Adj. Omni Bank, Spintex Road, Accra, Ghana
                                    </a>
                                </address>
                            </div>
                            <div className=' flex  items-center gap-2  text-white '>
                                <BiSolidEnvelope className="text-2xl md:text-3xl"/>
                                <address className='text-sm not-italic'>
                                    <p className='font-semibold'>Email us</p>
                                    <a href="mailto:info@ntubedglobal.com">info@ntubedglobal.com</a> <br />
                                    <a href="mailto:support@ntubedglobal.com">support@ntubedglobal.com</a>
                                </address>
                            </div>


                        </div>

                    </form>
                </div>
            </div>
            <div className="w-100">
                <iframe
                    title="Google Map showing Ntubed Global Ltd. location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d992.6430076519604!2d-0.09312503044883408!3d5.630011934282758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf850073154611%3A0x981b2a292ee51a00!2sNtubed%20global%20ltd.!5e0!3m2!1sen!2sgh!4v1705498673680!5m2!1sen!2sgh"
                    className="w-full"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade">
                </iframe>
            </div>

        </div>
    );
}

export default Contact;
